import React from 'react';
import PropTypes from 'prop-types';
import {Icon} from '@/components/atoms';
import './../../../assets/scss/custom/components/_uploadOutcomeDisplay.scss';

const UploadOutcomeDisplay = ({
  totalCount,
  nonExistentIds = [],
  fileName,
  onDelete
}) => {
  const [showAll, setShowAll] = React.useState(false);

  const successCount = totalCount - nonExistentIds.length;

  const renderSkippedIds = () => {
    if (nonExistentIds.length <= 3 || showAll) {
      return (
        <div>
          {nonExistentIds.map((id) => (
            <div key={id}>{id}</div>
          ))}
        </div>
      );
    }

    const visibleIds = nonExistentIds.slice(0, 3);
    const remainingCount = nonExistentIds.length - visibleIds.length;

    return (
      <div>
        {visibleIds.map((id) => (
          <div key={id}>{id}</div>
        ))}
        {remainingCount > 0 && (
          <button
            type='button'
            className='moreLink border-0 bg-transparent p-0'
            onClick={() => setShowAll(true)}>
            (+{remainingCount} more)
          </button>
        )}
      </div>
    );
  };

  return (
    <div className='uploadOutcomeDisplayContainer'>
      {fileName && (
        <div className='file-preview-row'>
          <Icon
            className='file-icon $spacing-mr03'
            icon={'insert_drive_file'}
            size={'small'}
          />
          <span className='file-name'>{fileName}</span>
          <button
            className='delete-file-btn'
            onClick={onDelete}
            aria-label='Remove file'>
            <Icon
              className='base-button-icon delete-file-btn'
              icon={'delete'}
              size={'small'}
            />
          </button>
        </div>
      )}
      {totalCount > 0 && (
        <div className='successMessage'>
          Successfully uploaded {successCount} out of {totalCount} products.
        </div>
      )}
      {nonExistentIds.length > 0 && (
        <div className='infoMessageText'>
          <div className='infoMessage'>
            <Icon className='copy-icon-color' icon={'info'} size={'small'} />
            <div>
              <strong>Product IDs:</strong> {nonExistentIds?.length} product IDs
              do not exist.
              <div>They are - {renderSkippedIds()}</div>
              <div>
                Please delete the file and re-upload with correct product IDs or
                click next to proceed anyway
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

UploadOutcomeDisplay.propTypes = {
  totalCount: PropTypes.number.isRequired,
  nonExistentIds: PropTypes.arrayOf(PropTypes.string).isRequired,
  fileName: PropTypes.string,
  onDelete: PropTypes.func
};

export default UploadOutcomeDisplay;
